module.exports = __webpack_public_path__ + "img/header_background.793f7ecf.png";